import { render, staticRenderFns } from "./removeButton.vue?vue&type=template&id=184b03c3&"
import script from "./removeButton.vue?vue&type=script&lang=js&"
export * from "./removeButton.vue?vue&type=script&lang=js&"
import style0 from "./removeButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports